import theme, { LOADED_THEME, zeroBorder } from '../../../../services/theme'

const baseRoot = {
    height: '48px',
    cursor: 'pointer',
    textTransform: 'none',
    color: theme.palette.leftPanel.color,
    backgroundColor: theme.palette.leftPanel.background,
    ['& .MuiTypography-body1']: {
        fontSize: '14px',
        fontWeight: '600 !important',
        color: theme.palette.leftPanel.color
    },
    [`&:hover`]: {
        backgroundColor: theme.palette.leftPanel.hover,
        color: theme.palette.leftPanel.hoverColor,
        ['& .MuiTypography-body1']: {
            color: theme.palette.leftPanel.hoverColor
        },
        ['& .MuiIcon-root']: {
            color: theme.palette.leftPanel.hoverColor
        }
    },
    [`&.disabled`]: {
        cursor: 'default',
        color: theme.palette.leftPanel.text,
        [`&:hover`]: {
            backgroundColor: theme.palette.background.transparent
        }
    }
}

const selected = {
    ...zeroBorder,
    backgroundColor: theme.palette.leftPanel.selected,
    color: theme.palette.leftPanel.selectedColor,
    paddingLeft: '12px',
    borderLeft: `4px solid ${theme.palette.leftPanel.selectedBorder}`,
    ['& .MuiTypography-body1']: {
        color: theme.palette.leftPanel.selectedColor
    },
    ['& .MuiIcon-root']: {
        color: theme.palette.leftPanel.selectedColor
    }
}

export default {
    root: {
        ...baseRoot,
        borderRadius: 0,
        [`&.selected`]: selected
    },
    rootPortal: {
        ...baseRoot,
        marginTop: '5px',
        marginBottom: '5px',
        borderRadius: LOADED_THEME.menuLeft.radius,
        [`&.selected`]: {
            ...selected,
            paddingLeft: '16px',
            borderLeft: 0,
            borderRadius: LOADED_THEME.menuLeft.radius
        }
    },
    link: {
        color: theme.palette.leftPanel.text,
        textDecoration: 'none'
    }
}